var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-checkbox',_vm._g(_vm._b({ref:"agreement",attrs:{"icon-size":"20px"}},'van-checkbox',_vm.$attrs,false),_vm.$listeners),[_vm._v(" 我已充分知情，并同意上传人脸照片用于申请和使用电子出入证 "),_c('span',{staticStyle:{"color":"#4BB1F8"},on:{"click":function($event){$event.stopPropagation();return _vm.showAgreement.apply(null, arguments)}}},[_vm._v(" 《电子出入证申请须知》 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }